import { render, staticRenderFns } from "./FormulaFieldConfiguratorWrapper.vue?vue&type=template&id=c4f4c2f4&scoped=true"
import script from "./FormulaFieldConfiguratorWrapper.vue?vue&type=script&lang=js"
export * from "./FormulaFieldConfiguratorWrapper.vue?vue&type=script&lang=js"
import style0 from "./FormulaFieldConfiguratorWrapper.vue?vue&type=style&index=0&id=c4f4c2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f4c2f4",
  null
  
)

export default component.exports